const jQueryRoot = window.jQuery || null

const JQueryVueBridgePluginService = {
  JQueryInstance: jQueryRoot
}

const JQueryVueBridgePlugin = {
  install: function (Vue, options) {
    if (jQueryRoot === null) {
      throw new Error("[jquery-vue-bridge-plugin] Unable to find a valid 'window.jQuery' jquery instance")
    }
    Vue.prototype.$jQuery = JQueryVueBridgePluginService.JQueryInstance
    Vue.jQuery = JQueryVueBridgePluginService.JQueryInstance
    Vue.mixin({
      data: () => {
        return {
          jQuery: JQueryVueBridgePluginService.JQueryInstance
        }
      }
    })
  }
}

export default JQueryVueBridgePlugin
